

export enum Direction {
  Right = "rotate(0deg)",
  Left = "rotate(180deg)",
  Up = "rotate(270deg)",
  Down = "rotate(90deg)",
}

type IconArrowProps = { size?: number; direction?: Direction } & React.SVGAttributes<SVGElement>;

const theSvg = (size, rest, direction: Direction = Direction.Right) => (
  <svg {...rest} style={{transform: direction, ...rest?.style}} width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Icon">
        <path
          id="Vector"
          d="M7.75004 14.4167C7.59726 14.264 7.52087 14.0695 7.52087 13.8334C7.52087 13.5973 7.59726 13.4029 7.75004 13.2501L11 10.0001L7.75004 6.75008C7.59726 6.5973 7.52087 6.40286 7.52087 6.16675C7.52087 5.93064 7.59726 5.73619 7.75004 5.58341C7.90282 5.43064 8.09726 5.35425 8.33337 5.35425C8.56948 5.35425 8.76393 5.43064 8.91671 5.58341L12.75 9.41675C12.8334 9.50008 12.8925 9.59036 12.9275 9.68758C12.962 9.7848 12.9792 9.88897 12.9792 10.0001C12.9792 10.1112 12.962 10.2154 12.9275 10.3126C12.8925 10.4098 12.8334 10.5001 12.75 10.5834L8.91671 14.4167C8.76393 14.5695 8.56948 14.6459 8.33337 14.6459C8.09726 14.6459 7.90282 14.5695 7.75004 14.4167Z"
          fill="currentColor"
        />
      </g>
  </svg>
);

export default function IconArrow({ size = 20, direction = Direction.Right, ...rest }: IconArrowProps) {
  return theSvg(size, rest, direction);
}

export function IconArrowLeft({ size = 20, ...rest }: IconArrowProps) {
  return theSvg(size, rest, Direction.Left);
}

export function IconArrowUp({ size = 20, ...rest }: IconArrowProps) {
  return theSvg(size, rest, Direction.Up);
}

export function IconArrowDown({ size = 20, ...rest }: IconArrowProps) {
  return theSvg(size, rest, Direction.Down);
}
